<div [ngSwitch]="getBannerType()">
    <reasons-to-buy-banner *ngSwitchCase="REASONS_TO_BUY_BANNER" [destinationCity]="destinationCity"></reasons-to-buy-banner>    
    <peggy-banner *ngSwitchCase="DRAPER_BANNER" [bannerData]="bannerData"></peggy-banner>
</div>